import { render, staticRenderFns } from "./CarrinhoOfertaAgrupamentoFrete.vue?vue&type=template&id=22f2a618"
import script from "./CarrinhoOfertaAgrupamentoFrete.vue?vue&type=script&lang=js"
export * from "./CarrinhoOfertaAgrupamentoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports